// ClientsTab's read (finance-real, the user 2026-10-23): the open status tab's clients on jobs and its footer.
import type { UseQueryResult } from "@tanstack/react-query";
import { useJobClients } from "../../hooks/useAgencyTabs";
import type { JobClients, JobClientsShow } from "../../types";

export type ClientsTabModel = UseQueryResult<JobClients>;

export function useClientsTab(show: JobClientsShow): ClientsTabModel {
  return useJobClients(show);
}
